import { render } from "./TenantModal.vue?vue&type=template&id=3b24cd64"
import script from "./TenantModal.vue?vue&type=script&lang=js"
export * from "./TenantModal.vue?vue&type=script&lang=js"

import "./TenantModal.vue?vue&type=style&index=0&id=3b24cd64&lang=scss"

import exportComponent from "/Users/pavel/FrontReportTechnomoscow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__